// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3ZnTZ","tableContainer":"styles_tableContainer__2FDuE","noPaginationWrapper":"styles_noPaginationWrapper__1sMbO"};